module.exports = __webpack_public_path__ + "static/media/sedanDark.62b37dd5.svg";